import SigninRouts from '../modules/Authintication/routes' 
import Errors from '../modules/Errors/routes'
import MassageScreens from '../modules/MassageScreens/routes'
import Settings from '../modules/Settings/routes'
import Teacher from '../modules/Teacher/routes'
import common from '../modules/Common/routes'

export default [...SigninRouts,...Errors,...MassageScreens,...Settings, ...Teacher, ...common]
